import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Gavel, ShieldCheck, Scale } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';

const Terms = () => {
    const { language } = useLanguage();

    const texts = {
        tr: {
            title: 'Kullanım Koşulları',
            lastUpdated: 'Son Güncelleme: 25 Mart 2026',
            sections: [
                {
                    title: '1. Kabul Etme',
                    content: 'Cplus Media LLC web sitesini ve hizmetlerini kullanarak, bu kullanım koşullarını kabul etmiş olursunuz.'
                },
                {
                    title: '2. Hizmetler',
                    content: 'Cplus Media LLC; dijital pazarlama, web geliştirme, Amazon ve Etsy danışmanlığı gibi dijital hizmetler sunar.'
                },
                {
                    title: '3. Ödeme Koşulları',
                    content: 'Hizmetlerimiz için belirtilen fiyatlar üzerinden ödeme yapılır. Ödemeler Stripe üzerinden güvenli bir şekilde işlenir.'
                },
                {
                    title: '4. Sorumluluk Reddinde Bulunma',
                    content: 'Hizmetlerimiz "olduğu gibi" sunulmaktadır ve sonuç garantisi verilmez. Cplus Media LLC, doğrudan veya dolaylı zararlardan sorumlu tutulamaz.'
                },
                {
                    title: '5. Uygulanacak Hukuk',
                    content: 'Bu sözleşme Wilmington, DE, ABD yasalarına tabidir.'
                }
            ]
        },
        en: {
            title: 'Terms of Service',
            lastUpdated: 'Last Updated: March 25, 2026',
            sections: [
                {
                    title: '1. Acceptance',
                    content: 'By using the Cplus Media LLC website and its services, you agree to these terms of service.'
                },
                {
                    title: '2. Services',
                    content: 'Cplus Media LLC provides digital services such as digital marketing, web development, Amazon and Etsy consulting.'
                },
                {
                    title: '3. Payment Terms',
                    content: 'Payment is made at the prices specified for our services. Payments are processed securely via Stripe.'
                },
                {
                    title: '4. Disclaimer',
                    content: 'Our services are provided "as is" and no results are guaranteed. Cplus Media LLC cannot be held responsible for direct or indirect damages.'
                },
                {
                    title: '5. Governing Law',
                    content: 'This agreement is governed by the laws of Wilmington, DE, USA.'
                }
            ]
        }
    };

    const t = texts[language] || texts.tr;

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-20 text-gray-800 dark:text-gray-100">
            <SEO 
                title={t.title}
                description="Cplus Media LLC Terms of Service"
            />
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white dark:bg-gray-900 rounded-3xl p-8 md:p-12 shadow-xl border border-gray-200 dark:border-gray-800"
                >
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/30 rounded-xl flex items-center justify-center text-purple-600 dark:text-purple-400">
                            <Gavel className="w-6 h-6" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{t.title}</h1>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{t.lastUpdated}</p>
                        </div>
                    </div>

                    <div className="space-y-8">
                        {t.sections.map((section, idx) => (
                            <div key={idx} className="space-y-3">
                                <h2 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-purple-600 rounded-full" />
                                    {section.title}
                                </h2>
                                <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-lg">
                                    {section.content}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 pt-8 border-t border-gray-100 dark:border-gray-800">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Contact Us: <a href="mailto:info@cplus.com.tr" className="text-blue-600 hover:underline">info@cplus.com.tr</a> | Address: 520 Robinson LN Unit 4C-15 4616 Wilmington, DE 19805 US
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Terms;
